import { render, staticRenderFns } from "./RichTextEditorImage.vue?vue&type=template&id=af8b2abe&scoped=true&"
import script from "./RichTextEditorImage.vue?vue&type=script&lang=js&"
export * from "./RichTextEditorImage.vue?vue&type=script&lang=js&"
import style0 from "./RichTextEditorImage.vue?vue&type=style&index=0&id=af8b2abe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8b2abe",
  null
  
)

export default component.exports